module.exports = __webpack_public_path__ + "img/ai2 (1).aa7937bc.png";